import {Component, OnDestroy, OnInit} from '@angular/core';
import {ComponentsService} from '@Services/navbar/components-navbar.service';
import {ComponentItem} from '@Common/home/navbar/dynamic-core-components/component-item';
import {MenuNavComponent} from '@Common/home/navbar/components/menu-nav.component';
import {AuthService, IndividuService} from '@Common/core/services';

import {Subscription} from 'rxjs';

import {PubSubService} from './common/services/pub-sub.service';
import {typeEvents} from './common/enum/type-events';
import {SnackBarToastyService} from '@Common/widgets/general/snack-bar/snack-bar-toasty.service';
import {SnackBarDataModel} from '@Common/widgets/general/snack-bar/snack-bar-data.model';
import {typeToast} from '@Common/widgets/general/snack-bar';
import {rolesBdc} from './common/enum/roles-bdc';
import {FeedBackNavComponent} from './common/components/feedback-nav-component';
import {environment} from "@Env/environment";


@Component({
  selector: 'p8-bdc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'WikiP8';
  menu = [];

  showLoader = false;
  subloading: Subscription;
  baseUrlRag: string;
  askPath: string;
  eventPubSub: Map<string, Subscription> = new Map<string, Subscription>([
    [typeEvents.roleUpdated,
      this.pubsubService.on(typeEvents.roleUpdated).subscribe((msg) => {
        this.toasty('Accès', msg, typeToast.success);
      })],
    [typeEvents.roleExisted,
      this.pubsubService.on(typeEvents.roleExisted).subscribe((msg) => {
        this.toasty('Accès', msg, typeToast.warning);
      })],
    [typeEvents.pageSaved,
      this.pubsubService.on(typeEvents.pageSaved).subscribe((msg) => {
        this.toasty('Page', msg, typeToast.success);
      })],
    [typeEvents.imageSaved,
      this.pubsubService.on(typeEvents.imageSaved).subscribe((msg) => {
        this.toasty('Image', msg, typeToast.success);
      })],
    [typeEvents.docSaved,
      this.pubsubService.on(typeEvents.docSaved).subscribe((msg) => {
        this.toasty('Document', msg, typeToast.success);
      })],

    [typeEvents.likeSaved,
      this.pubsubService.on(typeEvents.likeSaved).subscribe((msg) => {
        this.toasty('', msg, typeToast.success);
      })],

    [typeEvents.commentSaved,
      this.pubsubService.on(typeEvents.commentSaved).subscribe((msg) => {
        this.toasty('', msg, typeToast.success);
      })],

    [typeEvents.noPageRights,
      this.pubsubService.on(typeEvents.noPageRights).subscribe((msg) => {
        this.toasty('', msg, typeToast.error);
      })],
  ]);

  constructor(private individuService: IndividuService,
              private authService: AuthService,
              private componentsSvc: ComponentsService,
              private pubsubService: PubSubService,
              private snackSvc: SnackBarToastyService) {

  }

  getComponents() {
    return [
      new ComponentItem(MenuNavComponent, this.menu),
      new ComponentItem(FeedBackNavComponent, {}, 'feedbackNavCmp')
    ];
  }

  private clearMenu() {
    this.menu = [
      // {url: '', titre: 'Accueil', nav: true, icon: 'home'},
    ];
  }

  ngOnInit() {
    this.clearMenu();
    this.baseUrlRag= environment.baseUrl;
    this.askPath= `/api_rag/ask/`;

    this.componentsSvc.setComponents(this.getComponents());

    this.individuService.individu$.subscribe(_individu => {
      this.clearMenu();

      if (this.individuService.hasRole(_individu, rolesBdc.gestionnaire)) {
        this.menu = [
          {url: '/settings', titre: 'Edition', nav: false, icon: 'local_library'},
        ];
      }



      if (this.individuService.hasRole(_individu, rolesBdc.supergestionnaire)) {
        this.menu = [
          {url: '/settings', titre: 'Contenu', nav: false, icon: 'local_library'},
        ];
      }

      if (this.individuService.hasRole(_individu, rolesBdc.admin)) {
        this.menu = [
          {url: '/settings', titre: 'Contenu', nav: false, icon: 'local_library'},
          {url: '/admin', titre: 'Admin', nav: false, icon: 'settings'},
        ];
      }

        this.componentsSvc.setComponents(this.getComponents());
      }
    );

    this.subloading = this.pubsubService.on('loading').subscribe((val) => {
      setTimeout(_ => this.showLoader = val);
    });
  }

  connectedUser(state = null): boolean {
    return this.authService.loggedIn();
  }

  showChatbot(): boolean {
    return this.connectedUser() && (environment.env === 'dev' || environment.env === 'test');
  }

  ngOnDestroy(): void {
    if (this.subloading) {
      this.subloading.unsubscribe();
    }

    this.eventPubSub.forEach((value: Subscription, key: string) => {
        if (value) {
          value.unsubscribe();
        }
      }
    );
  }

  /**
   * Affichage du toaster
   *
   * @param {string} title
   * @param {string} msg
   * @param {typeToast} type
   */
  toasty(title: string, msg: string, type: typeToast) {
    const config: SnackBarDataModel = {
      title: title,
      message: msg,
      type: type,
      showClose: true
    };

    this.snackSvc.openSnackToasty(config);
  }
}
